import { Accordion } from '@chakra-ui/react';
import styled from 'styled-components';

export const PTOScheduleGroup = styled.div`
  margin-top: 32px;

  &:first-of-type {
    margin-top: 16px;
  }
`;

export const PTOScheduleGroupTitle = styled.p`
  display: block;
  font-size: 16px;
  font-style: normal;
  line-height: 120%;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin-bottom: 16px;

  & > strong {
    font-weight: 600;
    margin-right: 8px;
    display: inline-block;
  }
`;

export const PTOScheduleList = styled(Accordion)`
  background: ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
  overflow: hidden;

  & > div:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.colors['neutral-30']};
  }
`;
